import { render, staticRenderFns } from "./ManagementIndicators.vue?vue&type=template&id=7476dff8&scoped=true&"
import script from "./ManagementIndicators.vue?vue&type=script&lang=js&"
export * from "./ManagementIndicators.vue?vue&type=script&lang=js&"
import style0 from "./ManagementIndicators.vue?vue&type=style&index=0&id=7476dff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476dff8",
  null
  
)

export default component.exports